import { notifyError } from "../components/Toast";

// Acción para obtener tipos de documento
export const GetTipoDocumento = () => {
  return async (dispatch) => {
    dispatch({ type: "LOAD_TIPODOC_REQUEST" });

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/checkout/tipoDocumento`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const tiposDoc = await response.json();
        const tiposDocStructured = tiposDoc.map((tipoDoc) => ({
          value: tipoDoc.Código,
          label: tipoDoc.Descripción,
        }));

        dispatch({ type: "LOAD_TIPODOC_SUCCESS", payload: tiposDocStructured });
      } else {
        const errorMessage = await response.text();
        dispatch({ type: "LOAD_TIPODOC_FAIL", payload: errorMessage });
        notifyError("Hubo un error al cargar los tipos de documento.");
      }
    } catch (error) {
      dispatch({ type: "LOAD_TIPODOC_FAIL", payload: error.message });
      notifyError("Error de conexión al cargar los tipos de documento.");
    }
  };
};

export const GetTipoDocumentoEmpresa = () => {
  return async (dispatch) => {
    dispatch({ type: "LOAD_TIPODOC_REQUESTEMPRESAS" });

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/checkout/getTipoDocumentoEmpresas`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const tiposDoc = await response.json();
        const tiposDocStructured = tiposDoc.map((tipoDoc) => ({
          value: tipoDoc.Código,
          label: tipoDoc.Descripción,
        }));

        dispatch({ type: "LOAD_TIPODOC_SUCCESSEMPRESAS", payload: tiposDocStructured });
      } else {
        const errorMessage = await response.text();
        dispatch({ type: "LOAD_TIPODOC_FAILEMPRESAS", payload: errorMessage });
        notifyError("Hubo un error al cargar los tipos de documento.");
      }
    } catch (error) {
      dispatch({ type: "LOAD_TIPODOC_FAILEMPRESAS", payload: error.message });
      notifyError("Error de conexión al cargar los tipos de documento.");
    }
  };
};

// Acción para obtener profesiones
export const GetProfesiones = () => {
  return async (dispatch) => {
    dispatch({ type: "LOAD_PROFESIONES_REQUEST" });

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/checkout/profesiones`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const profesiones = await response.json();
        dispatch({ type: "LOAD_PROFESIONES_SUCCESS", payload: profesiones });
      } else {
        const errorMessage = await response.text();
        dispatch({ type: "LOAD_PROFESIONES_FAIL", payload: errorMessage });
        notifyError("Hubo un error al cargar las profesiones.");
      }
    } catch (error) {
      dispatch({ type: "LOAD_PROFESIONES_FAIL", payload: error.message });
      notifyError("Error de conexión al cargar las profesiones.");
    }
  };
};

// Acción para obtener profesiones
export const GetTipoSolicitudEstudiante = () => {
  return async (dispatch) => {
    dispatch({ type: "LOAD_TIPO_PROFESIONES_REQUEST" });

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/checkout/solicitudes/tipos`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const types = await response.json();

        const typesStructured = types.map((type) => ({
          value: type.c_valor_id.trim(),
          label: type.vc_descripcion.trim(),
        }));
        dispatch({ type: "LOAD_TIPO_PROFESIONES_SUCCESS", payload: typesStructured });

      } else {
        const errorMessage = await response.text();
        dispatch({ type: "LOAD_TIPO_PROFESIONES_FAIL", payload: errorMessage });
        notifyError("Hubo un error al cargar las profesiones.");
      }
    } catch (error) {
      dispatch({ type: "LOAD_TIPO_PROFESIONES_FAIL", payload: error.message });
      notifyError("Error de conexión al cargar las profesiones.");
    }
  };
};


// Acción para obtener estado civil
export const GetEstadoCivil = () => {
  return async (dispatch) => {
    dispatch({ type: "LOAD_ESTADOCIVIL_REQUEST" });

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/checkout/EstadoCivil`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const estadosCiviles = await response.json();
        dispatch({ type: "LOAD_ESTADOCIVIL_SUCCESS", payload: estadosCiviles });
      } else {
        const errorMessage = await response.text();
        dispatch({ type: "LOAD_ESTADOCIVIL_FAIL", payload: errorMessage });
        notifyError("Hubo un error al cargar los estados civiles.");
      }
    } catch (error) {
      dispatch({ type: "LOAD_ESTADOCIVIL_FAIL", payload: error.message });
      notifyError("Error de conexión al cargar los estados civiles.");
    }
  };
};

// Acción para obtener países
export const GetPaises = () => {
  return async (dispatch) => {
    dispatch({ type: "LOAD_PAISES_REQUEST" });

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/checkout/Paises`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const paises = await response.json();
        const paisesStructured = paises?.map((pais) => {
          const [key, value] = Object.entries(pais)[0]; // Obtiene la primera clave y su valor
          return { value, label: pais.vc_descripcion };
        })

        dispatch({ type: "LOAD_PAISES_SUCCESS", payload: paisesStructured });
      } else {
        const errorMessage = await response.text();
        dispatch({ type: "LOAD_PAISES_FAIL", payload: errorMessage });
        notifyError("Hubo un error al cargar los países.");
      }
    } catch (error) {
      dispatch({ type: "LOAD_PAISES_FAIL", payload: error.message });
      notifyError("Error de conexión al cargar los países.");
    }
  };
};

export const GetProvincias = () => {
  return async (dispatch) => {
    dispatch({ type: "LOAD_PROVINCIAS_REQUEST" });

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/checkout/provincias`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const provincias = await response.json();
        const provinciasStructured = provincias.map((prov) => ({
          value: prov.c_provincia_id.trim(),
          label: prov.vc_descripcion.trim(),
        }));

        dispatch({ type: "LOAD_PROVINCIAS_SUCCESS", payload: provinciasStructured });
      } else {
        const errorMessage = await response.text();
        dispatch({ type: "LOAD_PROVINCIAS_FAIL", payload: errorMessage });
        notifyError("Hubo un error al cargar las provincias");
      }
    } catch (error) {
      dispatch({ type: "LOAD_PROVINCIAS_FAIL", payload: error.message });
      notifyError("Error de conexión al cargar las provincias");
    }
  };
};

// Acción para obtener información de "Conocio" general
export const GetConocio = () => {
  return async (dispatch) => {
    dispatch({ type: "LOAD_CONOCIO_REQUEST" });

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/checkout/Conocio`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const conocio = await response.json();
        dispatch({ type: "LOAD_CONOCIO_SUCCESS", payload: conocio });
      } else {
        const errorMessage = await response.text();
        dispatch({ type: "LOAD_CONOCIO_FAIL", payload: errorMessage });
        notifyError("Hubo un error al cargar las opciones de 'Conoció'.");
      }
    } catch (error) {
      dispatch({ type: "LOAD_CONOCIO_FAIL", payload: error.message });
      notifyError("Error de conexión al cargar las opciones de 'Conoció'.");
    }
  };
};

// Acción para obtener información de "Conocio" general
export const GetEligio = () => {
  return async (dispatch) => {
    dispatch({ type: "LOAD_ELIGIO_REQUEST" });

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/checkout/Eligio`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const eligioOpciones = await response.json();
        const eliigoStructured = eligioOpciones?.map((eligio) => {
          const [key, value] = Object.entries(eligio)[0]; // Obtiene la primera clave y su valor
          return { value, label: eligio.vc_descripcion };
        })
        dispatch({ type: "LOAD_ELIGIO_SUCCESS", payload: eliigoStructured });
      } else {
        const errorMessage = await response.text();
        dispatch({ type: "LOAD_ELIGIO_FAIL", payload: errorMessage });
        notifyError("Hubo un error al cargar las opciones de 'Eligio'.");
      }
    } catch (error) {
      dispatch({ type: "LOAD_ELIGIO_FAIL", payload: error.message });
      notifyError("Error de conexión al cargar las opciones de 'Eligio'.");
    }
  };
};

export const GetNivelEstudioPadres = () => {
  return async (dispatch) => {
    dispatch({ type: "LOAD_NIVELESTUDIOP_REQUEST" });

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/checkout/NivelEstudio`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.ok) {
        const nvlEstudio = await response.json();
        const nvlEstudioStructured = nvlEstudio.map((nivelEstudio) => ({
          value: nivelEstudio.Código,
          label: nivelEstudio.Descripción,
        }));

        dispatch({ type: "LOAD_NIVELESTUDIOP_SUCCESS", payload: nvlEstudioStructured });
      } else {
        const errorMessage = await response.text();
        dispatch({ type: "LOAD_NIVELESTUDIOP_FAIL", payload: errorMessage });
        notifyError("Hubo un error al cargar los tipos de estudios.");
      }
    } catch (error) {
      dispatch({ type: "LOAD_NIVELESTUDIOP_FAIL", payload: error.message });
      notifyError("Error de conexión al cargar los tipos de estudios.");
    }
  };
};

export const SendMailDataUser = (tipoDocumento, numeroDocumento, carrera) => {
  return async (dispatch) => {
    dispatch({ type: "SEND_MAIL_DATA_USER_REQUEST" });

    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}/checkout/user/mail?tipoDocumento=${encodeURIComponent(tipoDocumento)}&numeroDocumento=${encodeURIComponent(numeroDocumento)}&carrera=${encodeURIComponent(carrera)}`;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const mails = await response.json();
        dispatch({ type: "SEND_MAIL_DATA_USER_SUCCESS",payload: mails });
        return mails;
      } else {
        const errorMessage = await response.text();
        dispatch({ type: "SEND_MAIL_DATA_USER_FAIL", payload: errorMessage });
       return false;
      }
    } catch (error) {
      dispatch({ type: "SEND_MAIL_DATA_USER_FAIL", payload: error.message });
     return false;
    }
  };
};

export const GetCue = (cue) => {
  return async (dispatch) => {
    if (!cue) {
      notifyError("El CUE no puede estar vacío.");
      return;
    }

    dispatch({ type: "LOAD_CUE_REQUEST" });

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/checkout/CUE?nroCue=${cue}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const data = await response.json();
        const formattedData = data.map((item) => ({
          nombre: item.vc_nombre,
          provincia: item.provincia_id,
          localidad: item.localidad,
          domicilio: item.domicilio,
          codigoPostal: item.codigopostal,
          departamento: item.departamento,
          jurisdiccion: item.jurisdiccion,
        }));

        dispatch({ type: "LOAD_CUE_SUCCESS", payload: formattedData });
      } else {
        const errorMessage = await response.text();
        dispatch({ type: "LOAD_CUE_FAIL", payload: errorMessage });
        notifyError("Hubo un error al cargar la información del CUE.");
      }
    } catch (error) {
      dispatch({ type: "LOAD_CUE_FAIL", payload: error.message });
      notifyError("Error de conexión al cargar la información del CUE.");
    }
  };
};


//SMS
export const SendSMS = (nombre, numero, code = "") => {
  return async (dispatch) => {
    dispatch({ type: "SEND_SMS_REQUEST" });

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/sms/SendSms`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Nombre: nombre,
          NroCelular: numero,
          Code: code, // Se envía el código aunque sea vacío
        }),
      });

      if (response.ok) {
        dispatch({ type: "SEND_SMS_SUCCESS" });
      //  notifySuccess("Mensaje enviado con éxito."); // Agregado para feedback
      } else {
        const errorMessage = await response.text();
        dispatch({ type: "SEND_SMS_FAIL", payload: errorMessage });
        notifyError("Hubo un error al enviar el SMS.");
      }
    } catch (error) {
      dispatch({ type: "SEND_SMS_FAIL", payload: error.message });
      notifyError("Error de conexión al enviar el SMS.");
    }
  };
};


export const verifyCodeSMS = (nombre, numero, code) => {
  return async (dispatch) => {
    dispatch({ type: "VERIFY_SMS_REQUEST" });

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/sms/ValidateSms`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Nombre: nombre,
          NroCelular: numero,
          Code: code,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        if (data.message === "valid") {
          dispatch({ type: "VERIFY_SMS_SUCCESS" });
          return true;
        }else{
          dispatch({ type: "VERIFY_SMS_FAIL", payload: "Código incorrecto o expirado." });
          notifyError("El código ingresado no es válido.");
          return false;
        }
      } else {
        const errorMessage = await response.text();
        dispatch({ type: "VERIFY_SMS_FAIL", payload: errorMessage });
        notifyError("Hubo un error al verificar el código.");
      }
    } catch (error) {
      dispatch({ type: "VERIFY_SMS_FAIL", payload: error.message });
      notifyError("Error de conexión al verificar el código.");
    }
  };
};

export const sendMailValidation = (mail) => {
  return async (dispatch) => {
    dispatch({ type: "SEND_MAIL_VALIDATION_REQUEST" });

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/checkout/user/mail/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify( mail ), // El backend espera directamente un string, no un objeto
      });

      if (response.ok) {
        dispatch({ type: "SEND_MAIL_VALIDATION_SUCCESS" });
        // notifySuccess("El correo fue enviado correctamente.");
      } else {
        const errorMessage = await response.text();
        dispatch({ type: "SEND_MAIL_VALIDATION_FAIL", payload: errorMessage });
        // notifyError("Error al enviar el correo.");
      }
    } catch (error) {
      dispatch({ type: "SEND_MAIL_VALIDATION_FAIL", payload: error.message });
      // notifyError("Error de conexión al enviar el correo.");
    }
  };
};


export const verifyMailValidation = (mail, code) => {
  return async (dispatch) => {
    dispatch({ type: "VERIFY_MAIL_VALIDATION_REQUEST" });

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/checkout/user/mail/validation`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          mail: mail,
          code: code,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        if(data.message === "valid") {
          dispatch({ type: "VERIFY_MAIL_VALIDATION_SUCCESS" });
          return true;
        }
        dispatch({ type: "VERIFY_MAIL_VALIDATION_SUCCESS" });
        return false;
      } else {
        dispatch({ type: "VERIFY_MAIL_VALIDATION_FAIL", payload: "Código inválido" });
         return false;
      }
    } catch (error) {
      dispatch({ type: "VERIFY_MAIL_VALIDATION_FAIL", payload: error.message });
      // notifyError("Error de conexión al verificar el código.");
    }
  };
};




